export function sortEntityByName(entityA: { name: string }, entityB: { name: string }) {
  return entityA.name.localeCompare(entityB.name, undefined, { numeric: true, sensitivity: "base" });
}
